module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.recover($event)
      }
    }
  }, [(_vm.error) ? _c('error-indicator', {
    attrs: {
      "error": _vm.error
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui left icon input"
  }, [_c('i', {
    staticClass: "user icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "name": "login",
      "placeholder": "E-Mail/Benutzername"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.success === false) ? _c('div', {
    staticClass: "ui orange message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.success = null
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n      Zurücksetzen fehlgeschlagen\n    ")]), _vm._v("\n    Es konnte kein Benutzer mit diesem Login gefunden werden (oder ein Zurücksetzen des Passworts ist nicht möglich [z.B. durch externen EDWIN-Login]).\n  ")]) : _vm._e(), _vm._v(" "), (_vm.success === true) ? _c('div', {
    staticClass: "ui green message"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": function($event) {
        _vm.success = null
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("\n      Passwort erfolgreich zurückgesetzt\n    ")]), _vm._v("\n    Eine E-Mail mit dem neuen Passwort ist zu Ihnen unterwegs!\n    "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Zum Login")])], 1) : _vm._e(), _vm._v(" "), (_vm.success !== true) ? _c('button', {
    staticClass: "ui fluid green submit button",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Zurücksetzen")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('loading-indicator') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    Geben Sie die Login-E-Mail Ihres Benutzers ein und klicken Sie auf „Zurücksetzen\". Ein neues Passwort wird in Kürze automatisch verschickt."), _c('br'), _vm._v("\n    Berücksichtigen Sie bitte, dass es bei der Übertragung auch zu Wartezeiten kommen kann. Sollte sich die Benachrichtigung nicht im Posteingang befinden, kontrollieren Sie ebenfalls Ihren Spamverdacht-Ordner.\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1401d0ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/recover/components/page.vue
// module id = 357
// module chunks = 0